<template>
  <b-container fluid class="p-4">
    <b-row>
      <b-col><h3 class="mb-4">ساخت کاربر</h3></b-col>
      <b-col class="text-left">
        <router-link :to="{ name: 'User' }">
          <b-button pill variant="primary">لیست کاربران</b-button>
        </router-link>
      </b-col>
    </b-row>
    <profile-component
        :submit="createPerson"
        :user="form"
    />
  </b-container>
</template>

<script>
import {mapGetters} from "vuex";
import ProfileComponent from "../Profile.vue";

export default {
  name: "Create",
  components: {ProfileComponent},
  data() {
    return {
      form: {
        email_verified_at: null,
        email: null,
        cellphone_verified_at: null,
        cellphone: null,
      }
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: "User/isAdmin",
      person: "User/getPerson",
    }),
  },
  methods: {
    createPerson(form) {
      this.$store.dispatch("User/createPerson", form);
    },
  },
};
</script>

<style scoped>
</style>